import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

// import required modules
import { Pagination } from "swiper/modules";
import { useSelector } from "react-redux";

export default function ImageInfo({ imageInfo, setImageInfo }) {
  const data = useSelector((state) => state.main.data?.photosData)?.filter(
    (item) => item.clinc_id == "1"
  );
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
  return (
    imageInfo && (
      <div className="image-info" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setImageInfo(false)}
        ></div>
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          slidesPerView={"auto"}
          centeredSlides={true}
          spaceBetween={20}
          modules={[Pagination, Navigation]}
          className="container "
        >
          {data?.map((section) => (
            <>
              <SwiperSlide className="section">
                <div className="image">
                  <img
                    src={`https://api.atharalfarasha.com/public/hakim/${section?.photo_name}`}
                    alt=""
                  />
                </div>
                <div className="data">
                  <div className="title">
                    <span>{section?.photo_info}</span>
                  </div>
                </div>
              </SwiperSlide>
            </>
          ))}
        </Swiper>
      </div>
    )
  );
}
